<h2 mat-dialog-title>Upload Document</h2>
<mat-dialog-content>
  <div class="space-y-4">
    <!-- File Selection -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">Select File</label>
      <input
        type="file"
        #fileInput
        (change)="onFileSelected($event)"
        class="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
      />
      <div *ngIf="selectedFile" class="mt-2 p-3 bg-gray-50 rounded-md">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm font-medium text-gray-900">{{ selectedFile.name }}</p>
            <p class="text-xs text-gray-500">{{ formatFileSize(selectedFile.size) }}</p>
          </div>
          <button mat-icon-button (click)="selectedFile = null; fileInput.value = ''">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Project (required for upload) -->
    <div *ngIf="projectLocked" class="rounded-md bg-slate-50 border border-slate-200 px-4 py-3">
      <div class="text-xs font-semibold text-slate-500 uppercase tracking-wide">Project</div>
      <div class="text-base font-semibold text-slate-900">{{ projectDisplayName || 'Loading…' }}</div>
    </div>

    <mat-form-field *ngIf="!projectLocked" class="w-full" subscriptSizing="dynamic">
      <mat-label>Project</mat-label>
      <mat-select [(ngModel)]="projectId" [disabled]="projectsLoading">
        <mat-option [value]="null">Select project</mat-option>
        <mat-option *ngFor="let p of projectsForSelect" [value]="p.id">
          {{ p.project_name }}
        </mat-option>
      </mat-select>
      <mat-hint *ngIf="projectsLoading">Loading projects…</mat-hint>
    </mat-form-field>

    <!-- Document Name -->
    <mat-form-field  class="w-full">
      <mat-label>Document Name</mat-label>
      <input matInput [(ngModel)]="documentName" placeholder="Enter document name">
    </mat-form-field>

    <!-- Description -->
    <mat-form-field  class="w-full">
      <mat-label>Description</mat-label>
      <textarea matInput [(ngModel)]="description" rows="3" placeholder="Enter description"></textarea>
    </mat-form-field>

    <!-- Category -->
    <mat-form-field  class="w-full">
      <mat-label>Category</mat-label>
      <mat-select [(ngModel)]="categoryId">
        <mat-option [value]="null">Select Category</mat-option>
        <mat-option *ngFor="let category of categories" [value]="category.id">
          {{ category.category_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Tags -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">Tags</label>
      <div class="flex gap-2 mb-2">
        <input
          matInput
          [(ngModel)]="tagInput"
          (keyup.enter)="addTag()"
          placeholder="Add tag and press Enter"
          class="flex-1"
        >
        <button mat-raised-button color="primary" (click)="addTag()">Add</button>
      </div>
      <div class="flex flex-wrap gap-2">
        <span *ngFor="let tag of tags" class="tag-chip">
          <span class="tag-chip-label">{{ tag }}</span>
          <button
            type="button"
            class="tag-chip-remove"
            (click)="removeTag(tag)"
            aria-label="Remove tag"
          >
            <mat-icon>close</mat-icon>
          </button>
        </span>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="uploading">Cancel</button>
  <button mat-raised-button color="primary" (click)="upload()" [disabled]="!canSubmit">
    <span *ngIf="uploading">Uploading...</span>
    <span *ngIf="!uploading">Upload</span>
  </button>
</mat-dialog-actions>


